import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Projects from '../components/Projects'; // This is the landing page section
import Collaborators from '../components/Collaborators';
import FAQ from '../components/FAQ';
import Location from '../components/Location';
import RoomTypes from '../components/RoomTypes';
import ConstructionDetails from '../components/ConstructionDetails';
import Contact from '../components/Contact';

function HomePage() {
    return (
        <>
            <Hero />
            <div className="bg-[#eceeF1]">
                <Services />
                <Projects />
                <Collaborators />
                <RoomTypes />
                <ConstructionDetails />
                <FAQ />
                <Location />
                <Contact />
            </div>
        </>
    );
}

export default HomePage;
